import { HttpClient } from '@angular/common/http';
import { InjectionToken, inject } from '@angular/core';
import { BehaviorSubject, Observable, map, tap } from 'rxjs';

export const STATIC_JSON_BASE_URL = new InjectionToken<string>('STATIC_JSON_BASE_URL');

export abstract class BaseHrmLookupClient<T> {
  protected abstract readonly FILE_PATH: string;
  protected readonly _cacheSubject = new BehaviorSubject<T[]>([]);
  protected cache$?: Observable<T[]>;

  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(STATIC_JSON_BASE_URL);

  protected getCachedOrFetch(): Observable<T[]> {
    if (this.cache$) {
      return this.cache$;
    } else {
      this.cache$ = this._cacheSubject.asObservable();

      return this.fetch();
    }
  }

  protected abstract mapFileToModel(data: unknown): T[];

  private fetch(): Observable<T[]> {
    return this.http.get(this.baseUrl + this.FILE_PATH).pipe(
      map(this.mapFileToModel.bind(this)),
      tap((data: T[]) => this._cacheSubject.next(data)),
    );
  }
}
